import { type App } from 'vue';
import * as Sentry from '@sentry/vue';
import { env } from '@/utility';

const initErrorTracker = (app: App) => {
  Sentry.init({
    app,
    dsn: env.sentryDsn,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    sendDefaultPii: true,
    tracesSampleRate: 0.001,
    tracePropagationTargets: ['localhost', env.baseApiUrl, /^\//],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
};

export default initErrorTracker;
